module.exports = __webpack_public_path__ + "img/index_yewu_zhjt.bf002eb2.png";